import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { toast } from "sonner";
import { Save } from "lucide-react";

const FIELDS = [
  { key: "address_tr", label: "Adres (TR)" },
  { key: "address_en", label: "Address (EN)" },
  { key: "phone", label: "Telefon" },
  { key: "email", label: "E-posta" },
];

export default function AdminContact() {
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/content/contact").then((r) => setForm(r.data.data || {})).catch(() => {});
  }, []);

  const onChange = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const save = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.put("/admin/content/contact", { data: form });
      toast.success("İletişim bilgileri güncellendi");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Hata");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-contact-page" className="p-10 max-w-2xl">
      <div className="overline text-[#4A6A8F]">İçerik</div>
      <h1 className="font-serif-ap text-4xl text-[#0F2746] mt-3">İletişim Bilgileri</h1>
      <p className="text-[#3A5170] mt-3">İletişim sayfasında ve footer'da gösterilen bilgileri düzenleyin.</p>

      <form onSubmit={save} className="mt-10 space-y-6">
        {FIELDS.map((f) => (
          <label key={f.key} className="block">
            <span className="overline text-[10px] text-[#4A6A8F] block mb-2">{f.label}</span>
            <input
              data-testid={`field-${f.key}`}
              value={form[f.key] || ""}
              onChange={onChange(f.key)}
              className="w-full bg-white border-b border-[#0F2746]/30 focus:border-[#0F2746] outline-none py-2 text-[#0F2746]"
            />
          </label>
        ))}
        <button
          type="submit"
          disabled={loading}
          data-testid="save-contact-btn"
          className="bg-[#0F2746] text-[#F3F5F8] hover:bg-[#081A33] disabled:opacity-50 px-8 py-3 text-xs uppercase tracking-[0.2em] flex items-center gap-2"
        >
          <Save size={14} /> {loading ? "..." : "Kaydet"}
        </button>
      </form>
    </div>
  );
}
